import React from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import ContactSec from "../../components/ContactSec";
import FormHeadings from "../../components/FormHeadings";
import { Link } from "react-router-dom";
import { ClipIcon } from "../../constant";
import { useNavigate } from "react-router-dom";
const SermonDetailsNikkahProof = () => {
	const navigate = useNavigate();
	const handleSubmit = (event) => {
		event.preventDefault();
		// perform form submission logic here
		navigate("/nikkah-proof-witness-details-1"); // navigate to the success page
	};
	return (
		<>
			<Header />
			<section className="custom-forms">
				<div className="container">
					<FormHeadings
						SmallHeading="Manchester Islamic Centre"
						MainHeading="Proof of Nikah Form"
						containerSize="col-xl-9 col-lg-9 col-md-10 col-sm-12 mx-auto px-xl-4"
						Text="Diam ut venenatis tellus in metus vulputate eu scelerisque. Commodo nulla facilisi nullam vehicula ipsum a arcu cursus vitae. Sed risus ultricies tristique nulla. Arcu cursus vitae congue mauris rhoncus aenean vel. Et egestas "
					/>
					<div className="col-xl-7 col-lg-9 col-md-10 col-sm-12 mx-auto">
						<div className="custom-form-start">
							<h6 className="form-inner-heading mt-1 mb-3">
								Nikah Sermon Details
							</h6>
							<form onSubmit={handleSubmit}>
								<div className="row">
									<div className="col-md-6">
										<div className="form-group mb-3">
											<label htmlFor="DateofNikah">
												Date of Nikah/Islamic Marriage
											</label>
											<input
												type="text"
												name="DateofNikah"
												id="DateofNikah"
												className="form-control"
												placeholder="Your answer"
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-3">
											<label htmlFor="PlaceofNikah">Place of Nikah</label>
											<input
												type="text"
												name="PlaceofNikah"
												id="PlaceofNikah"
												className="form-control"
												placeholder="Your answer"
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-3">
											<label htmlFor="amountofDowrymahr">
												Please include the amount and details of Dowry (Mahr)
												agreed upon
											</label>
											<input
												type="text"
												name="amountofDowrymahr"
												id="amountofDowrymahr"
												className="form-control"
												placeholder="Your answer"
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-3">
											<label htmlFor="marriageconditions">
												Were there any marriage conditions stated?*
											</label>
											<input
												type="text"
												name="marriageconditions"
												id="marriageconditions"
												className="form-control"
												placeholder="Your answer"
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-3">
											<label htmlFor="">
												Have you had a Civil Registration of Marriage? *
											</label>
											<div className="custom-check-box-default">
												<label className="label-checkbox">
													Yes
													<input type="checkbox" />
													<span className="checkmark"></span>
												</label>
												<label className="label-checkbox">
													No
													<input type="checkbox" />
													<span className="checkmark"></span>
												</label>
											</div>
										</div>
									</div>
									<div className="col-md-12 me-md-4">
										<div className="form-group mb-3">
											<label htmlFor="dateofCivilMarriage">
												If Yes , please give the date of the UK Civil Marriage
											</label>
											<input
												type="text"
												name="dateofCivilMarriage"
												id="dateofCivilMarriage"
												className="form-control"
												placeholder="Your answer"
											/>
										</div>
									</div>
									<div className="col-md-12 me-md-4">
										<div className="form-group mb-3">
											<label htmlFor="NameRegistryOffice">
												Name of UK Registry Office
											</label>
											<input
												type="text"
												name="NameRegistryOffice"
												id="NameRegistryOffice"
												className="form-control"
												placeholder="Your answer"
											/>
										</div>
									</div>
									<div className="col-md-12 me-md-4">
										<div className="form-group mb-3">
											<label htmlFor="CivilMarriagenumber">
												Civil Marriage reference number
											</label>
											<input
												type="text"
												name="CivilMarriagenumber"
												id="CivilMarriagenumber"
												className="form-control"
												placeholder="Your answer"
											/>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group mb-3 pt-3">
											<label htmlFor="">
												Please Upload Your Civil Marriage Certificate Here
											</label>
											<div className="file-uploader-custom">
												<label htmlFor="UploadFile" className="fileuploader">
													<input
														type="file"
														name="UploadFile"
														hidden
														id="UploadFile"
													/>
													<span>
														Drag & Drop .PDF Files here or click to upload
													</span>
												</label>
												<div className="col-md-6 px-0">
													<div className="files-list">
														<div className="single-file">
															<div className="icon-text">
																<img src={ClipIcon} alt="" />
																<span>Attachment 1 .pdf</span>
															</div>
															<span className="removefile">Remove</span>
														</div>
														<div className="single-file">
															<div className="icon-text">
																<img src={ClipIcon} alt="" />
																<span>Attachment 1 .pdf</span>
															</div>
															<span className="removefile">Remove</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-12 mt-2">
										<div className="form-group d-flex gap-3">
											<Link
												to="/nikkah-proof-wife-details"
												className="btn ms-auto px-5"
											>
												Back
											</Link>
											<button type="submit" className="btn px-5">
												Next
											</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</section>
			<ContactSec />
			<Footer />
		</>
	);
};
export default SermonDetailsNikkahProof;
